import React, { useState, useEffect } from "react";
import axios from "axios";

const ProjectsArchive = () => {
  const [projects, setProjects] = useState([]);
  const [services, setServices] = useState([]);
  const [specialisms, setSpecialisms] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedSpecialism, setSelectedSpecialism] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage] = useState(6);
  const [maxPage, setMaxPage] = useState(1);

  const paginationParam = `&per_page=${perPage}&page=${page}`;

  const updateData = async (append = false) => {
    let searchString = "";
    if (selectedService) {
      searchString += `&service=${selectedService.id}`;
    }
    if (selectedSpecialism) {
      searchString += `&specialism-type=${selectedSpecialism.id}`;
    }

    try {
      const results = await axios.get(
        `/wp-json/gs/v1/get_projects?${searchString}${paginationParam}`
      );
      setMaxPage(+results.headers["x-wp-totalpages"]);
      if (!append) {
        setProjects(results.data);
      } else {
        setProjects((prevProjects) => [...prevProjects, ...results.data]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const loadNextPage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const servicesData = await axios.get(
          `/wp-json/wp/v2/service?per_page=100`
        );
        const specialismsData = await axios.get(
          `/wp-json/wp/v2/specialism-type?per_page=100`
        );
        setServices(servicesData.data);
        setSpecialisms(specialismsData.data);
        await updateData();
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    updateData();
  }, [selectedService, selectedSpecialism, page]);

  const handleServiceChange = (event) => {
    const id = +event.target.value;
    setSelectedService(services.find((x) => x.id === id) || null);
  };

  const handleSpecialismChange = (event) => {
    const id = +event.target.value;
    setSelectedSpecialism(specialisms.find((x) => x.id === id) || null);
  };

  return (
    <div className="projectsarchive">
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
            <select
              className="w-100"
              onChange={handleServiceChange}
              defaultValue=""
            >
              <option value="">Filter by Service</option>
              {services.length > 0 &&
                services.map((item, index) => (
                  <option key={`service-${index}`} value={item.id}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-lg-3">
            <select
              className="w-100"
              onChange={handleSpecialismChange}
              defaultValue=""
            >
              <option value="">Filter by Specialism</option>
              {specialisms.length > 0 &&
                specialisms.map((item, index) => (
                  <option key={`spec-${index}`} value={item.id}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="row">
          {projects.length > 0 ? (
            projects.map((project, index) => (
              <div
                className="col-md-6 col-sm-12 projectsarchive__card"
                key={`project-${index}`}
              >
                <a
                  href={project.url}
                  className="projectsarchive__photocontainer"
                >
                  <img
                    className="projectsarchive__photo"
                    src={project.image}
                    alt={project.name}
                  />
                </a>
                <h3 className="projectsarchive__title">{project.name}</h3>
                <div
                  className="projectsarchive__excerpt"
                  dangerouslySetInnerHTML={{ __html: project.excerpt }}
                ></div>
                <a className="projectsarchive__readmore" href={project.url}>
                  Read more...
                </a>
              </div>
            ))
          ) : (
            <p className="noresults">There are no results for this search</p>
          )}
        </div>
        {page < maxPage && (
          <div className="row">
            <div className="col-md-12">
              <button className="cta mx-auto pointer" onClick={loadNextPage}>
                View More
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsArchive;
